import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {EntityStoreUser} from 'constants/EntityStoreConstants';
import {getTabStyles, navBarIconStyles} from 'nav/navbar/NavBarStyles';
import {ITEM_SIZE_SIDE_NAVBAR} from 'styles/StyleConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import Avatar from 'ui-library/avatar/Avatar';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {WHITE} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import UserMenu from './UserMenu';

export interface UserIconProps {
  currentUser: EntityStoreUser;
  isActive: boolean;
}

export default function UserIcon(props: UserIconProps): JSX.Element | null {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  if (!props.currentUser) {
    return null;
  }
  return (
    <div
      className={css(getTabStyles(props.isActive), styles.item)}
      {...getTestProps({
        component: 'UserIcon',
        element: 'root',
      })}
    >
      <UserMenu currentUser={props.currentUser} isOpen={isDropdownOpen} setIsOpen={setIsDropdownOpen}>
        <div className={classNames(css(navBarIconStyles.iconWrapper), 'dropdown')}>
          <div
            className={classNames(css(navBarIconStyles.inner), 'dropdown-toggle')}
            {...getTestProps({component: 'UserIcon', element: 'userDropdownButton'})}
          >
            <Avatar entity={props.currentUser} size={AvatarSize.SMALL} />
            {Boolean(BenchlingConfig.VALIDATED_CLOUD_VERSION) && (
              <BenchlingIcon className={css(styles.validatedBadge)} icon="validated-cloud" />
            )}
          </div>
        </div>
      </UserMenu>
    </div>
  );
}

const styles = StyleSheet.create({
  item: {
    bottom: 0,
    position: 'fixed',
    width: ITEM_SIZE_SIDE_NAVBAR,
  },
  validatedBadge: {
    position: 'absolute',
    bottom: 7,
    right: 7,
    height: 20,
    width: 20,
    fill: WHITE,
  },
});
